import { getFullUrlPure } from 'hubspot-url-utils/pure';
import { loadBalancers } from '../constants';
import enviro from '../util/enviro';
/**
 * Middleware that ensures URLs are absolute using hubspot-url-utils.
 * The URL constructor automatically handles both relative and absolute URLs:
 * - Relative URLs are resolved against the base URL
 * - Absolute URLs are used as-is (the base is ignored)
 */
export const addHostPure = (params, context) => {
  const inputStr = params.input.toString();
  const useLongLivedLb = context.useLongLivedLb;
  const isLocal = inputStr === null || inputStr === void 0 ? void 0 : inputStr.includes('chirp-frontend-local');
  const loveLivedAppAuthBaseUrl = getFullUrlPure(isLocal ? 'local' : 'chirp-stream-app', context.hublet || enviro.getHublet(), context.env || enviro.getShort(), {
    domainOverride: 'hubspot',
    hubletizeNa1: !isLocal
  });
  const longLivedinternalAuthBaseUrl = getFullUrlPure(isLocal ? 'local' : 'chirp-stream-internal', context.hublet || enviro.getHublet(), context.env || enviro.getShort(), {
    domainOverride: 'hubteam',
    hubletizeNa1: !isLocal
  });

  // If already an absolute URL, return with string input
  // This should never happen for on stack streaming CHIRP RPCs
  if (inputStr.startsWith('http://') || inputStr.startsWith('https://')) {
    if (useLongLivedLb) {
      try {
        const url = new URL(inputStr);
        const pathname = url.pathname;
        return Object.assign({}, params, {
          input: `${context.loadBalancer === loadBalancers.APP ? loveLivedAppAuthBaseUrl : longLivedinternalAuthBaseUrl}${pathname}`
        });
      } catch (error) {
        // TODO: Probably log this but it should never happen
        return Object.assign({}, params, {
          input: inputStr
        });
      }
    }
    return Object.assign({}, params, {
      input: inputStr
    });
  }

  // Map our load balancer constants to hubspot-url-utils subdomain strings
  let baseUrl;
  if (useLongLivedLb) {
    baseUrl = context.loadBalancer === loadBalancers.APP ? loveLivedAppAuthBaseUrl : longLivedinternalAuthBaseUrl;
  } else {
    switch (context.loadBalancer) {
      case loadBalancers.APP:
        // Use 'app-api' which includes the /api path for app.hubspot.com
        baseUrl = getFullUrlPure('app-api', context.hublet || enviro.getHublet(), context.env || enviro.getShort());
        break;
      case loadBalancers.TOOLS:
        // For tools.hubteam.com
        baseUrl = getFullUrlPure('tools', context.hublet || enviro.getHublet(), context.env || enviro.getShort(), {
          domainOverride: 'hubteam'
        });
        break;
      case loadBalancers.PRIVATEHUBTEAM:
        // 'privatehubteam'
        // For private.hubteam.com

        baseUrl = getFullUrlPure('private', context.hublet || enviro.getHublet(), context.env || enviro.getShort(), {
          domainOverride: 'hubteam'
        });
        break;
      default:
        throw new Error(`Unknown load balancer: ${context.loadBalancer}`);
    }
  }

  // Parse the base URL to get origin and pathname
  const {
    origin,
    pathname
  } = new URL(baseUrl);

  // assumes inputStr starts with a slash, and pathname will either be "/", or start but not end with a slash ("/api")
  let finalPath = pathname + inputStr;
  if (finalPath.startsWith('//')) {
    finalPath = finalPath.slice(1);
  }
  const url = new URL(finalPath, origin);
  return Object.assign({}, params, {
    input: url.toString()
  });
};